// Selectors ==========================================================================================================================================================================
let modalIdReset = document.getElementById("modalIdReset");
let myTgrBtnReset = document.querySelector(".my-tgr-btn-reset");
let myInputReset = document.querySelector(".my-input-reset");
let myModalContentReset = document.querySelector(".my-modal-content-reset");
let myModalBtnReset = document.querySelector(".my-modal-btn-reset");
let myModalContentLoaderReset = document.querySelector(".my-modal-content-loader-reset");
let myModalContentConfirmationReset = document.querySelector(".my-modal-content-confirmation-reset");
let myModalContentErrorReset = document.querySelector(".my-modal-content-error-reset");
let myErrorMsg = document.querySelector(".my-error-msg");

// Edit Patient =======================================================================================================================================================================

// Modal trigger btn -----------------------------------------------------------------------
let modalReset;         // To create modal instance (and be able to show()).
myTgrBtnReset.addEventListener('click', (e) => {
    // Prevent submit of form
    e.preventDefault();
    // Read input value
    let inputValue = myInputReset.value;
    let expression = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,4}$/;
    
    // Reset modal content delete and validate null value
    if (!inputValue) {
        myModalContentReset.querySelector("i").classList.add("fa-exclamation");
        myModalContentReset.querySelector("p").innerHTML = `Email can not be empty`;
        myModalBtnReset.classList.add("d-none");

        // Create instance of modal
        modalReset = bootstrap.Modal.getOrCreateInstance(modalIdReset);
        modalReset.show();            
    } else if (expression.test(inputValue)) {     // Validate email format
        // Hide error msg
        myErrorMsg.classList.add("d-none");
        myModalContentReset.querySelector("i").classList.remove("fa-exclamation");
        myModalContentReset.querySelector("p").innerHTML = `Are you sure you want to <span class="text-success fw-bold">RESET PASSWORD</span> for patient <strong>${inputValue}</strong>?`;
        myModalBtnReset.classList.remove("d-none");
    
        // Create instance of modal
        modalReset = bootstrap.Modal.getOrCreateInstance(modalIdReset);
        modalReset.show();    
    } else {
        // Show error msg
        myErrorMsg.classList.remove("d-none");
    }
})

// Modal btn  -----------------------------------------------------------------------------
let reset = false;  // To track reset operation.
myModalBtnReset.addEventListener('click', () => {
    // Get the id to be updated
    let id = myInputReset.value;
        
    // Activate loader
    myModalContentReset.classList.add('d-none');
    myModalContentLoaderReset.classList.remove('d-none');
    // Call resetPasswordAPI function
    resetPasswordAPI(id);
});

// Reset Password API -----------------------------------------------------------------------------
let error = false; // To track error.
async function resetPasswordAPI(id) {
    let idEncoded = encodeURIComponent(id);
    // let url = encodeURI(`${process.env.SELFHELP_API}/reset-password?user=${localStorage.getItem("username")}&email=${idEncoded}&isPatient=True`);
    let url = encodeURI(`${process.env.NEW_SELFHELP_ADMIN_API}/admin/reset-password?email=${idEncoded}`);
    await fetch(url, {
        method: "PUT",
        mode: 'cors',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Content-Type': 'application/json'               // THIS LINE IS SUPER IMPORTANT.
        }
    }).catch(error => {
        console.log("API response - Error:");
        console.log(error);
        
        // Hide loader
        myModalContentLoaderReset.classList.add('d-none');
        // Show error
        myModalContentConfirmationReset.querySelector("p").innerHTML = error;
        myModalContentConfirmationReset.classList.remove('d-none');

        reset = false;
        error = true;
    }).then (async response => {

        if (response.status != 400 && response.status != 403 && response.status != 404 && response.status != 500 && response.status != 502) {
            console.log("API response - Success:");
            let responseParsed = await response.json();
            let data = responseParsed['data'];
            let password = data.password;

            // Hide loader
            myModalContentLoaderReset.classList.add('d-none');
            // Show confirmation
            myModalContentConfirmationReset.querySelector("p").innerHTML = `Password for patient <strong>${id}</strong> has been reset to ${password}`
            myModalContentConfirmationReset.classList.remove('d-none');

            reset = true;

        } else {
            let responseParsed = await response.json();

            console.log("API response - Error:");
            console.log(responseParsed);
            
            // Hide loader
            myModalContentLoaderReset.classList.add('d-none');
            // Show error
            myModalContentErrorReset.querySelector("p").innerHTML = responseParsed.message;
            myModalContentErrorReset.classList.remove('d-none');

            reset = false;
            error = true;
        }
    });
}

// Reset modal after deleting -----------------------------------------------------------
modalIdReset.addEventListener('hidden.bs.modal', event => {
    if (reset) {
        myModalContentConfirmationReset.classList.add('d-none');
        myModalContentReset.classList.remove('d-none');
        myInputReset.value = "";

        reset = false;          // Reset operation.
    }

    if (error) {
        myModalContentErrorReset.classList.add('d-none');
        myModalContentReset.classList.remove('d-none');

        error = false;          // Reset error.
    }
})